// eslint-disable-next-line
import { Box, FormControl, FormErrorMessage, Select } from '@chakra-ui/react';

interface Props {
  brandsAndRanges: BrandAndRangesType;
  selectedMake?: string;
  disableMake?: boolean;
  selectedModel?: string;
  disableModel?: boolean;
  disableVariant?: boolean;
  selectedVariant?: string;
  defaultVariants?: { id: number; name: string }[];
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  errors: any;
}

import { useEffect, useState } from 'react';
import { UseFormRegister, UseFormSetValue } from 'react-hook-form';

import { BrandAndRangesType } from '@/services/filters/new-filters.service';
import { getVariants } from '@/services/SpecialsService.service';

import Styles from './usedCar-select.module.scss';

export default function UsedCarSelect({
  brandsAndRanges,
  selectedMake,
  disableMake,
  selectedModel,
  disableModel,
  selectedVariant,
  disableVariant,
  defaultVariants,
  register,
  setValue,
  errors,
}: Props) {
  const models =
    brandsAndRanges.find((brand) => brand.name === selectedMake)?.range_ids ||
    [];

  const [variants, setVariants] = useState(defaultVariants || []);

  const fetchVariants = async (rangeId: number) => {
    const fetchedVariants = await getVariants(rangeId);

    setVariants(fetchedVariants);
  };

  useEffect(() => {
    setValue('vehicle_brand', selectedMake);
  }, [selectedMake]);

  useEffect(() => {
    setValue('vehicle_range', selectedModel);
  }, [selectedModel]);

  useEffect(() => {
    setValue('vehicle_model', selectedVariant);
  }, [selectedVariant]);

  useEffect(() => {
    const model = models.find((model) => model.name === selectedModel);

    if (model) {
      fetchVariants(model.id);
    }
  }, [selectedModel]);

  return (
    <>
      <FormControl id="vehicle_brand" isInvalid={!!errors.vehicle_brand}>
        <Box className={Styles.customSelect}>
          <Select
            className={Styles.formInput}
            placeholder="Select make"
            variant="flushed"
            defaultValue={selectedMake}
            disabled={disableMake}
            {...register('vehicle_brand', {
              required: 'Please select a make',
            })}
          >
            <option value="" disabled>
              Select model
            </option>
            {brandsAndRanges?.map((make) => (
              <option key={make.id} value={make.name}>
                {make?.name}
              </option>
            ))}
          </Select>
        </Box>

        <FormErrorMessage>
          {errors.vehicle_brand && errors.vehicle_brand.message?.toString()}
        </FormErrorMessage>
      </FormControl>

      <FormControl id="vehicle_brand" isInvalid={!!errors.vehicle_brand}>
        <Box className={Styles.smallCustomSelect}>
          <Select
            className={Styles.formInput}
            placeholder="Select model"
            variant="flushed"
            disabled={disableModel}
            defaultValue={selectedModel}
            {...register('vehicle_range', {
              required: 'Please select a model',
              onChange: async (value) => {
                const model = models.find((model) => model.name === value);

                if (model) {
                  fetchVariants(model.id);
                }
              },
            })}
          >
            <option value="" disabled>
              Select model
            </option>
            {models?.map((models) => (
              <option key={models.id} value={models.name}>
                {models?.name}
              </option>
            ))}
          </Select>
        </Box>

        <FormErrorMessage>
          {errors.vehicle_range && errors.vehicle_range.message?.toString()}
        </FormErrorMessage>
      </FormControl>

      <FormControl id="vehicle_model" isInvalid={!!errors.vehicle_brand}>
        <Box className={Styles.smallCustomSelect}>
          <Select
            className={Styles.formInput}
            placeholder="Select variant"
            variant="flushed"
            disabled={disableVariant}
            defaultValue={selectedVariant}
            {...register('vehicle_model')}
          >
            <option value="" disabled>
              Select variant
            </option>
            {variants?.map((variant) => (
              <option key={variant.id} value={variant.name}>
                {variant?.name}
              </option>
            ))}
          </Select>
        </Box>
        <FormErrorMessage>
          {errors.vehicle_model && errors.vehicle_model.message?.toString()}
        </FormErrorMessage>
      </FormControl>
    </>
  );
}
